
<!-- <ngx-spinner></ngx-spinner> -->
<ngx-spinner bdColor = "rgba(0,0,0,0.1)" size = "medium" color = "#464343" type = "ball-spin-clockwise"></ngx-spinner>
<router-outlet></router-outlet>